<script setup lang="ts">

import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import {storeToRefs} from "pinia";
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import {computed, ref} from "vue";
import ProgressPopupItem from "@/components/progress/ProgressPopupItem.vue";
import GUIActionResult = namaTypes.GUIActionResult;

const {tasks, tasksCount} = storeToRefs(useLoginInfoStore());
const isPopupVisible = ref(false);

const tasksCountString = computed(() => {
  return tasksCount.value > 99 ? '+99' : String(tasksCount.value);
})

</script>

<template>
  <div class="tw-flex tw-justify-center">
    <div :title="Translator.translateId('progressController')"
         class="tw-relative focus:tw-outline-none focus-visible:tw-ring-2 tw-mx-2.5 focus-visible:tw-ring-white/75 hover:tw-cursor-pointer">
      <NamaIcon default-icon="downloading" class="tw-size-6"/>
      <span class="tw-absolute tw-bg-red-600 tw-rounded-[25%] tw-text-sm tw-p-1 tw-text-namaFontColor-input-dark tw--top-1/3 tw-left-3/4 tw-leading-[10px]"
            v-if="tasksCount>0">{{ tasksCountString }}</span>
    </div>
    <q-menu v-model="isPopupVisible" self="top middle" :offset=[40,15] id="tasksMenu" class="tw-max-h-screen">
      <div class="tw-flex tw-flex-col tw-max-h-[60vh] tw-w-full desktop:tw-max-w-[70vw] desktop:tw-min-w-96">
        <div>
          <ProgressPopupItem v-for="(result, index) in tasks" :key="index" :result="result as GUIActionResult"/>
        </div>
      </div>
    </q-menu>
  </div>
</template>

<style scoped>
#tasksMenu {
  @apply dark:tw-bg-namaBackground-deep-dark
}
</style>
